(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      connectedCallback() {
        if (this._wired) return
        this._wired = true
        this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]')
        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        )
      }

      onItemClick(event) {
        event.preventDefault()
        const form = this.querySelector('form')
        if (!form || !this.input) return
        this.input.value = event.currentTarget.dataset.value
        form.submit()
      }
    }
    customElements.define('localization-form', LocalizationForm)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('localization-form')) {
    class LocalizationForm extends HTMLElement {
      connectedCallback() {
        if (this._wired) return
        this._wired = true
        this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]')
        this.querySelectorAll('a').forEach((item) =>
          item.addEventListener('click', this.onItemClick.bind(this))
        )
      }

      onItemClick(event) {
        event.preventDefault()
        const form = this.querySelector('form')
        if (!form || !this.input) return
        this.input.value = event.currentTarget.dataset.value
        form.submit()
      }
    }
    customElements.define('localization-form', LocalizationForm)
  }

  } catch(e) { console.error(e); }
})();
})();
